import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import noop from 'lodash/noop'

import Form, {SubmitButton, Input} from 'modules/common/components/Form'

import validationSchema from './schema'

const initialValues = {name: '', pin: ''}

const ChatLogin = ({heading, isLoading, disabled, hasError, onSubmit}) => {
  return (
    <div className="box">
      {heading && (
        <>
          {heading} <hr className="hr" />
        </>
      )}
      <p className="paragraph is-size-7">
        Fill in the details and hit the start chatting button to get started
        with the chat.
      </p>
      <Form
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}>
        <Input
          id="chatRoomLoginForm_name"
          label="Name"
          name="name"
          helpText="Your name help others to identify you while chatting."
          placeholder="Max Mustermann"
          disabled={disabled}
        />
        <Input
          id="chatRoomLoginForm_pin"
          label="PIN"
          name="pin"
          helpText="Enter the PIN that was shared with you for the chat."
          autoComplete="off"
          disabled={disabled}
        />
        <div className="columns">
          <div className="column" />
          <div className="column is-half">
            <SubmitButton
              className={classNames('button is-warning is-fullwidth', {
                'is-loading': isLoading,
              })}
              name="chatRoomLoginForm_submit"
              disabled={disabled}>
              Start Chatting
            </SubmitButton>
          </div>
        </div>
        {hasError && (
          <div className="notification is-danger">
            Invalid PIN, please re-enter pin and try again. If you don't know
            the pin, get in touch with the person who shared the chat link with
            you.
          </div>
        )}
      </Form>
    </div>
  )
}

ChatLogin.defaultProps = {
  hasError: false,
  isLoading: false,
  disabled: false,
  onSubmit: noop,
}

ChatLogin.propTypes = {
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  heading: PropTypes.node,
  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func,
}

export default ChatLogin
